import React from "react";
import defaultAvatar from "../images/user.png";
import "../styles/ClubPage.css";

const TeachersList = ({ clubData }) => {
    if (!clubData || !clubData.teachers) return <p>Loading teachers...</p>;

    return (
        <>
            <h2>Teachers</h2>
            <div className="teachers-list"> {/* ✅ This must be the grid container */}
                {clubData.teachers.length > 0 ? (
                    clubData.teachers.map((teacher, index) => (
                        <div key={index} className="teacher-card"> {/* ✅ Each card must be inside .teachers-list */}
                            <img
                                src={teacher.image?.startsWith("http") ? teacher.image : defaultAvatar}
                                alt={teacher.name}
                                className="teacher-avatar"
                            />
                            <div className="teacher-info">
                                <span className="teacher-name">
                                    {teacher.title ? `${teacher.title} ` : ""}{teacher.name}
                                </span>
                                <span className="teacher-position">{teacher.position}</span>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No teachers found.</p>
                )}
            </div>
        </>
    );
};

export default TeachersList;
